import API from "apiCalls/api";

export async function getBookingPackage(source, bookingId) {
  let response;
  try {
    response = await API.get(`booking-package-public/${bookingId}/`, {
      cancelToken: source.token,
    });
  } catch (error) {
    if (error.message) {
      response = error.response;
    } else {
      response = error;
    }
  }
  return response;
}

export async function createBookingPackage(token, source, body, bookingIdentifier) {
  let response;
  try {
    response = await API.post("booking-package/", body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
      params: { bookingId: bookingIdentifier },
    });
  } catch (error) {
    if (error.message) {
      response = error.response;
    } else {
      response = error;
    }
  }
  return response;
}

export async function createBookingPackagePublic(source, body, bookingIdentifier) {
  let response
  try {
    response = await API.post('booking-package-public/', body, {
      cancelToken: source.token,
      params: { bookingId: bookingIdentifier },
    })
  } catch (error) {
    if (error.message) {
      response = error.response
    } else {
      response = error
    }
  }
  return response
}


export async function updateBookingPackage(token, source, body, bookingId) {
  let response;
  try {
    response = await API.patch(`booking-package/${bookingId}/`, body, {
      headers: { Authorization: `token ${token}` },
      cancelToken: source.token,
    });
  } catch (error) {
    if (error.message) {
      response = error.response;
    } else {
      response = error;
    }
  }
  return response;
}
